export default "__VITE_ASSET__9c16c537__"